;
(function (ng) {
  'use strict';

  angular.module('readmore', []);
})(window.angular);